<script>
import Service from '@/services/material-balance'
import Utils from '@/common/Utils';
import ResponsiveButton from '@/components/generic/ResponsiveButton.vue';
import { FilterMatchMode } from 'primevue/api';
import GenericCustomMasterDataAutocompleteV2 from '@/components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import GenericCustomAutocompleteV2 from '@/components/generic/GenericCustomAutocompleteV2.vue';


export default{
    components: {
        ResponsiveButton,
        GenericCustomAutocompleteV2,
        GenericCustomMasterDataAutocompleteV2
    },
    mounted(){
        this.$store.dispatch('security/setNavbarTitle', 'compulsoryStock.page_title');
    },
    created() {
    },
    data(){
        return{
            referenceDate: Utils.setDay(new Date(), 1),
            idOwnerCompany: null,
            importData: [],
            processData: [],
            exportData: [],

            importDataFilters: {
                registryProduct:  { value: null, matchMode: FilterMatchMode.CONTAINS },
                ownerCompany:  { value: null, matchMode: FilterMatchMode.CONTAINS },
                originType: { value: null, matchMode: FilterMatchMode.CONTAINS },
                isImportable: { value: null, matchMode: FilterMatchMode.EQUALS },
            },
            processDataFilters:{
                registryProduct:  { value: null, matchMode: FilterMatchMode.CONTAINS },
                ownerCompany:  { value: null, matchMode: FilterMatchMode.CONTAINS },
                originType: { value: null, matchMode: FilterMatchMode.CONTAINS },
                productFamily: { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            exportDataFilters: {
                deposit:  { value: null, matchMode: FilterMatchMode.CONTAINS },
                ownerCompany:  { value: null, matchMode: FilterMatchMode.CONTAINS },
                product: { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            loadingImport: false,
            loadingProcess: false,
            loadingExport: false,

            editProcessItemVisible: false,
            editProcessItem: {}
        }
    },
    methods: {
        loadAll(){
            this.loadToImportData();
            this.loadToProcessData();
            this.loadToExportData();
        },
        loadToImportData(){
            this.importData = [];

            let params = {
                referenceDate: Utils.formatDateForAPI(this.referenceDate)
            }

            this.loadingImport = true;
            Service.getCompulsoryStocksToImport(params, (response) => {
                this.loadingImport = false;
                if(response.success){
                    this.importData = response.data;
                }else{
                     this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        loadToProcessData(){
            this.processData = [];

            let params = {
                referenceDate: Utils.formatDateForAPI(this.referenceDate)
            }

            this.loadingProcess = true;
            Service.getCompulsoryStocks(params, (response) => {
                this.loadingProcess = false;
                if(response.success){
                    this.processData = response.data;
                }else{
                     this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        loadToExportData(){
            this.exportData = [];

            let params = {
                referenceDate: Utils.formatDateForAPI(this.referenceDate),
                idOwnerCompany: this.idOwnerCompany
            }

            this.loadingExport = true;
            Service.getCompulsoryStocksMinisterialFormat(params, (response) => {
                this.loadingExport = false;
                if(response.success){
                    this.exportData = response.data;
                }else{
                     this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        onImport(){
            this.$confirm.require({
                message: this.$t('messages.importQuestion'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {

                    let params = {
                        referenceDate: Utils.formatDateForAPI(this.referenceDate)
                    }

                    Service.confirmCompulsoryStockToImport(params, 
                        response => {
                            if(response.success){
                                this.loadAll();
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.importSuccess'), life: 3000});
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        }
                    )
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        onUpdateProcessItem(item){
            this.editProcessItem= {...item};
            this.editProcessItemVisible = true;
        },
        onAdd(){
            this.editProcessItem= {
                referenceDate: Utils.formatDateForAPI(this.referenceDate)
            };
            this.editProcessItemVisible = true;
        },
        saveItem(){
            if(this.editProcessItem.id){
                this.$store.dispatch("generic/setLoading", true);
                Service.updateCompulsoryStock(this.editProcessItem, (response) => {
                    this.$store.dispatch("generic/setLoading", false);
                    this.editProcessItemVisible = false;
                    if(response.success){
                        this.loadToProcessData();
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }else{
                this.$store.dispatch("generic/setLoading", true);
                Service.createCompulsoryStock(this.editProcessItem, (response) => {
                    this.$store.dispatch("generic/setLoading", false);
                    this.editProcessItemVisible = false;
                    if(response.success){
                        this.loadToProcessData();
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }
        },
        onDeleteProcessItem(data){
            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    Service.deleteCompulsoryStock(data.id, 
                        response => {
                            if(response.success){
                                this.loadToProcessData();
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.importSuccess'), life: 3000});
                            }else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        }
                    )
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        onExportData(){

            let params = {
                referenceDate: Utils.formatDateForAPI(this.referenceDate),
                idOwnerCompany: this.idOwnerCompany
            }
            this.$store.dispatch("generic/setLoading", true);
            Service.exportCompulsoryStocksMinisterialFormat(params, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', Utils.formatDateWithFormat(this.referenceDate, 'yyMMDD') + '_ExportScorteMinistero.xlsx');
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        reloadProductsCombo(){
            this.$refs.productCompulsoryCombo.forceLoadOptions('masterdata/product-company-owner-combo?idCompanyOwner=' + this.editProcessItem.idOwnerCompany + '&referenceDate=' +  Utils.formatDateForAPI(this.editProcessItem.referenceDate))
        }
    },
    computed: {
        uiPermissions(){
            return this.$store.getters['security/uiPermissions'];
        },
    }
}
</script>

<template>
    <main>
        <Dialog v-model:visible="editProcessItemVisible" :style="{width: '85vw'}" :modal="true" >
            <div class="grid">
                <div class="col-12 lg:col-4">
                    <label for="idOwnerCompany">{{$t('compulsoryStock.ownerCompany')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        name="idOwnerCompany"
                        v-model="editProcessItem.idOwnerCompany"
                        :changeFn="reloadProductsCombo"
                        :api="'masterdata/company-combo?getOnlyValid=true&getOnlyCompulsoryStockEnabled=true'" />
                </div>
                <div class="col-12 lg:col-4">
                    <label for="idRegistryProduct">{{$t('compulsoryStock.registryProduct')}}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        ref="productCompulsoryCombo"
                        name="idRegistryProductCompulsory"
                        v-model="editProcessItem.idRegistryProduct" 
                        api="masterdata/product-company-owner-combo" />
                </div>
                <div class="col-12 lg:col-4">
                    <label for="quantity">{{$t('compulsoryStock.quantity')}}</label>
                    <InputNumber
                        class="w-full" 
                        mode="decimal" :maxFractionDigits="4" :minFractionDigits="4"
                        v-model="editProcessItem.quantity" />
                </div>
            </div>
                <template #footer>
                    <Button :label="$t('btn.save')" icon="pi pi-save" @click="saveItem" autofocus />
                </template>
        </Dialog>
        <TabView >
            <TabPanel :header="$t('compulsoryStock.importTab')" v-if="uiPermissions('CompulsoryStocks.Import').isEnabled">
                <div class="formgrid grid">
                    <div class="col-12 lg:col-3 field">
                        <label >{{ $t('compulsoryStock.referenceDate') }}</label>
                        <Calendar
                            :class="{ 'p-inputtext-sm w-full': true }"
                            v-model="referenceDate"
                            view="month" dateFormat="mm/yy" :showTime="false"
                            :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                    </div>
                    <div class="col-12 flex align-items-center lg:col-8 my-4">
                        <ResponsiveButton :label="$t('btn.load')" icon="pi pi-refresh" @click="loadAll" class="p-button-sm p-button-outlined m-1" />
                        <ResponsiveButton :label="$t('btn.import')" icon="pi pi-arrow-right" @click="onImport" class="p-button-sm p-button-outlined m-1" :disabled="!importData || importData.length == 0" />
                    </div>
                </div>
                <DataTable :value="importData" :reorderableColumns="true" :loading="loadingImport" v-model:filters="importDataFilters" filterDisplay="row">
                    <Column field="registryProduct" :header="$t('compulsoryStock.registryProduct')">
                        <template #filter="{ filterModel, filterCallback }">
                            <GenericCustomAutocompleteV2
                                v-model="filterModel.value" 
                                @change="filterCallback()"
                                :format="{label:'label',value:'label'}"
                                api="masterdata/product-company-owner-combo" />
                        </template>
                    </Column>
                    <Column field="ownerCompany" :header="$t('compulsoryStock.ownerCompany')">
                        <template #filter="{ filterModel, filterCallback }">
                            <GenericCustomAutocompleteV2
                                v-model="filterModel.value" 
                                @change="filterCallback()"
                                :format="{label:'label',value:'label'}"
                                api="masterdata/company-combo?getOnlyValid=true&getOnlyCompulsoryStockEnabled=true" />
                        </template>
                    </Column>
                    <Column field="quantity" :header="$t('compulsoryStock.quantity')" />
                    <Column field="originType" :header="$t('compulsoryStock.originType')">
                        <template #filter="{ filterModel, filterCallback }">
                            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" />
                        </template>
                    </Column>
                    <Column field="isImportable" :header="$t('compulsoryStock.isImportable')" dataType="boolean" style="min-width: 6rem">
                        <template #body="{ data }">
                            <i class="pi" :class="{ 'pi-check-circle text-green-500': data.isImportable, 'pi-times-circle text-red-400': !data.isImportable }"></i>
                        </template>
                        <template #filter="{ filterModel, filterCallback }">
                            <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()" class="p-column-filter" />
                        </template>
                    </Column>
                    <Column field="warning" :header="$t('compulsoryStock.warning')" />
                    <template #empty>
                        {{ $t('noRecordsFound') }}
                    </template>
                </DataTable>
            </TabPanel>
            <TabPanel :header="$t('compulsoryStock.processTab')" v-if="uiPermissions('CompulsoryStocks.Process').isEnabled">
                <div class="formgrid grid">
                    <div class="col-12 lg:col-3 field">
                        <label >{{ $t('compulsoryStock.referenceDate') }}</label>
                        <Calendar
                            :class="{ 'p-inputtext-sm w-full': true }"
                            v-model="referenceDate"
                            view="month" dateFormat="mm/yy" :showTime="false"
                            :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                    </div>
                    <div class="col-12 flex align-items-center lg:col-8 my-4">
                        <ResponsiveButton :label="$t('btn.load')" icon="pi pi-refresh" @click="loadAll" class="p-button-sm p-button-outlined m-1" />
                        <ResponsiveButton :label="$t('btn.add')" icon="pi pi-plus" @click="onAdd" class="p-button-sm p-button-outlined m-1" :disabled="!processData || processData.length == 0" />
                    </div>
                </div>
                <DataTable :value="processData" :reorderableColumns="true" :loading="loadingProcess" v-model:filters="processDataFilters" filterDisplay="row">
                    <Column class="button-column" :exportable="false">
                        <template #body="slotProps">
                            <ResponsiveButton icon="pi pi-pencil" class="p-button-sm p-button-rounded p-button-success mr-1 mb-1" v-tooltip="$t('btn.edit')" @click="onUpdateProcessItem(slotProps.data)"  size="small" />
                            <ResponsiveButton icon="pi pi-trash" class="p-button-sm p-button-rounded p-button-warning mr-1 mb-1" v-tooltip="$t('btn.delete')" @click="onDeleteProcessItem(slotProps.data)"  size="small" />
                        </template>
                    </Column>
                    <Column field="registryProduct" :header="$t('compulsoryStock.registryProduct')" >
                        <template #filter="{ filterModel, filterCallback }">
                            <GenericCustomAutocompleteV2
                                v-model="filterModel.value" 
                                @change="filterCallback()"
                                :format="{label:'label',value:'label'}"
                                api="masterdata/product-combo?getOnlyValid=true" />
                        </template>
                    </Column>
                    <Column field="ownerCompany" :header="$t('compulsoryStock.ownerCompany')" >
                        <template #filter="{ filterModel, filterCallback }">
                            <GenericCustomAutocompleteV2
                                v-model="filterModel.value" 
                                @change="filterCallback()"
                                :format="{label:'label',value:'label'}"
                                api="masterdata/company-combo?getOnlyValid=true&getOnlyCompulsoryStockEnabled=true" />
                        </template>
                    </Column>
                    <Column field="quantity" :header="$t('compulsoryStock.quantity')" />
                    <Column field="productFamily" :header="$t('compulsoryStock.productFamily')" >
                        <template #filter="{ filterModel, filterCallback }">
                            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" />
                        </template>
                    </Column>
                    <Column field="originType" :header="$t('compulsoryStock.originType')" >
                        <template #filter="{ filterModel, filterCallback }">
                            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter" />
                        </template>
                    </Column>
                    <template #empty>
                        {{ $t('noRecordsFound') }}
                    </template>
                </DataTable>
            </TabPanel>
            <TabPanel :header="$t('compulsoryStock.exportTab')" v-if="uiPermissions('CompulsoryStocks.Export').isEnabled">
                <div class="formgrid grid">
                    <div class="col-12 lg:col-3 field">
                        <label >{{ $t('compulsoryStock.referenceDate') }}</label>
                        <Calendar
                            :class="{ 'p-inputtext-sm w-full': true }"
                            v-model="referenceDate"
                            view="month" dateFormat="mm/yy" :showTime="false"
                            :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                    </div>
                    <div class="col-12 lg:col-3 field">
                        <label for="plant">{{$t('company.fk')}}</label>
                        <GenericCustomMasterDataAutocompleteV2
                            field="label"
                                :name="'registry-company'"
                            v-model="idOwnerCompany"
                            api="masterdata/company-combo?getOnlyValid=true&getOnlyCompulsoryStockEnabled=true"
                            :format="{ label: 'description', value: 'id' }"
                            :class="{'p-inputtext-sm w-full': true}" />
                    </div>
                    <div class="col-12 flex align-items-center lg:col-6 my-4">
                        <ResponsiveButton :label="$t('btn.load')" icon="pi pi-refresh" @click="loadAll" class="p-button-sm p-button-outlined m-1" />
                        <ResponsiveButton :label="$t('btn.download')" icon="pi pi-file-excel" @click="onExportData" class="p-button-sm p-button-outlined m-1" :disabled="!exportData || exportData.length == 0" />
                    </div>
                </div>
                <DataTable :value="exportData" :reorderableColumns="true" :loading="loadingExport">
                    <Column field="deposit" :header="$t('compulsoryStock.deposit')" />
                    <Column field="product" :header="$t('compulsoryStock.registryProduct')" />
                    <Column field="ownerCompany" :header="$t('compulsoryStock.ownerCompany')" />
                    <Column field="quantity" :header="$t('compulsoryStock.quantity')" />
                    <template #empty>
                        {{ $t('noRecordsFound') }}
                    </template>
                </DataTable>
            </TabPanel>
        </TabView>
    </main>
</template>